import React from 'react';
import { Controller } from 'react-hook-form';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const RHFAutocomplete = ({
  name,
  control,
  options,
  inputProps = {},
  freeSolo = false,
  rules,
  forceError,
  info,
  onChange: customOnChange,
  onInputChange,
  serviceMethods,
  loading,
  placeholder,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { onChange, value, ref }, fieldState: { error, invalid, isTouched } }) => {
      const handleChange = (event, newValue) => {
        onChange(newValue);
        if (customOnChange) {
          customOnChange(event, newValue);
        }
      };

      const handleBlur = event => {
        if (freeSolo) {
          onChange(event.target.value || null);
          serviceMethods?.dispatchClearOptions?.();
        }
      };

      return (
        <Autocomplete
          freeSolo={freeSolo}
          options={options}
          value={value ?? null}
          onChange={handleChange}
          onInputChange={onInputChange}
          loading={loading}
          renderInput={({ InputProps, ...params }) => (
            <TextField
              {...params}
              inputRef={ref}
              onBlur={handleBlur}
              placeholder={inputProps?.placeholder || inputProps?.label || placeholder}
              error={((isTouched || forceError) && invalid) || !!error}
              helperText={(((isTouched || forceError) || !!error) && error?.message) || info}
              {...inputProps}
              InputProps={{ ...(InputProps ?? {}), ...(inputProps?.InputProps ?? {}) }}
              type="search"
            />
          )}
          {...rest}
        />
      );
    }}
  />
);

export default RHFAutocomplete;
